import { ChevronDownIcon, ChevronUpIcon, Send } from "lucide-react";
import {
  FlowRunDetail,
  Trigger as TriggerModel,
} from "../../../../models/flows";
import { camelCase } from "lodash";
import { useState } from "react";
import { FormSubmitted } from "./triggers/FormSubmitted";
import { InputData } from "./InputData";
import { Manual } from "./triggers/Manual";
import { relativeDateAndTimeFormat } from "@/utils/date";

interface Props {
  flowRun: FlowRunDetail;
  expandTriggerInput?: boolean;
}

export const Trigger = ({ flowRun, expandTriggerInput }: Props) => {
  const triggerMap = {
    formSubmitted: "When an individual completes a form",
    manual: "When a flow is manually started",
  };

  return (
    <div className="relative">
      <div className="bg-yellow-500 h-full absolute w-0.5 ml-5 z-10 mt-8"></div>
      <div className="border dark:border-white/5 dark:bg-zinc-800 w-full rounded-md p-1.5">
        <div className="flex">
          <div className="bg-yellow-500 inline-flex p-1 rounded-md relative z-10">
            <Send className="h-5 w-5 text-white" />
          </div>
          <div className="flex items-center justify-between w-full ml-2 text-sm">
            <h2 className="dark:text-white font-medium text-zinc-500">
              {triggerMap[camelCase(flowRun.trigger.triggerType)]}
            </h2>
          </div>
        </div>
      </div>
      <div className="shadow-lg border dark:border-white/5 dark:bg-zinc-800 w-full rounded-md p-1.5 mt-2 relative text-zinc-500">
        <div className="ml-9 -mb-2 mt-3">
          <h5 className="text-xs mt-1 dark:text-zinc-300">
            {relativeDateAndTimeFormat(flowRun.startedAt)}
          </h5>
        </div>

        {flowRun.trigger.triggerType === "form_submitted" && (
          <FormSubmitted
            flowRun={flowRun}
            expandTriggerInput={expandTriggerInput}
          />
        )}

        {flowRun.trigger.triggerType === "manual" && (
          <>
            <InputData
              inputData={flowRun.triggerInput}
              dataUncollapsed={expandTriggerInput}
            />
            <Manual flowRun={flowRun} />
          </>
        )}
      </div>
    </div>
  );
};
